// extracted by mini-css-extract-plugin
module.exports = {"page":"StartPage_page__2xo0B","welcomeSegment":"StartPage_welcomeSegment__iEpwa","companyLogoSegment":"StartPage_companyLogoSegment__3FXmj"};